import React, { useMemo } from 'react';
import DataTable from '../Components/DataTable';
import FormattedDate from '../Components/FormattedDate';

function TablaClientes({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, clientes = [], ...props }) {
    const columns = useMemo(() => [
        {
            Header: 'ID',
            accessor: 'IdCliente',
        },
        {
            Header: 'Nombre',
            accessor: 'Nombres',
        },
        {
            Header: 'Apellidos',
            accessor: 'Apellidos',
        },
        {
            Header: 'Email',
            accessor: 'Email',
            Cell: ({ value }) => value ? (
                <a href={`mailto:${value}`} style={{ color: 'var(--color-primary, #00c0eb)' }}>
                    {value}
                </a>
            ) : '-'
        },
        {
            Header: 'Teléfono',
            accessor: 'Phone',
            Cell: ({ value }) => value || '-'
        },
        {
            Header: 'Fecha Nac.',
            accessor: 'Fecha_Nacimiento',
            Cell: ({ value }) => value ? <FormattedDate date={value} format="DD/MM/YYYY" /> : '-'
        },
        {
            Header: 'Ciudad',
            accessor: 'Ciudad',
            Cell: ({ value }) => value || '-'
        },
        {
            Header: 'Estado',
            accessor: 'Estado',
            Cell: ({ value }) => value || '-'
        }
    ], []);

    const getDefaultClientes = () => [
        {
            IdCliente: 1,
            Nombres: "Juan",
            Apellidos: "Pérez",
            Email: "juan@email.com",
            Phone: "1234567890",
            Fecha_Nacimiento: "1990-01-15",
            Ciudad: "México",
            Estado: "CDMX"
        }
    ];

    return (
        <DataTable
            data={(clientes && clientes.length > 0) ? clientes : getDefaultClientes()}
            columns={columns}
            idField="IdCliente"
            onSelectionChange={onSelectionChange}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="No hay clientes registrados"
            className="tabla-clientes"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaClientes;
